import React, { Component } from 'react';
import Calendar from './Calendar';
import Dropdown from './Dropdown';
import axios from 'axios';
import Navigation from './Navigation';
import Callback from './Callback';
import Promo from './Promo';
import Filter from './Filter';
import HomeBanner from './HomeBanner';
import SearchResult from './SearchResult';
import ShowRoom from './ShowRoom';
import MobileHome from './MobileHome';
import MobileFilter from './MobileFilter';
import MediaQuery from 'react-responsive';
import {roomsOptions} from '../config/options';

class Finder extends Component {

    constructor(props){
        super(props);

        this.state = {
            foundObjects: [],
            searchStarted : this.props.searchStarted,
            isSearching: false, 
            dateInterval: this.props.dateInterval,
            rooms: this.props.rooms,
            persons: this.props.persons,
            reason: this.props.reason,
            code: this.props.code,
            breakfast: this.props.breakfast,
            doublebed: this.props.doublebed,
            kitchen: this.props.kitchen,
            placeforkids: this.props.placeforkids,
            petsallowed: this.props.petsallowed,
            show: null
        }

        this.searchData = this.searchData.bind(this);
        this.handleIntervalselection = this.handleIntervalselection.bind(this);
        this.handleRoomsSelection = this.handleRoomsSelection.bind(this);
        this.handlePersonsSelection = this.handlePersonsSelection.bind(this);
        this.handleReasonSelection = this.handleReasonSelection.bind(this);
        this.handleCodeUpdate = this.handleCodeUpdate.bind(this);
        this.handleBreakfastSelection = this.handleBreakfastSelection.bind(this);
        this.handleDoublebedSelection = this.handleDoublebedSelection.bind(this);
        this.handleKitchenSelection = this.handleKitchenSelection.bind(this);
        this.handlePlaceforkidsSelection = this.handlePlaceforkidsSelection.bind(this);
        this.handlePetsallowedSelection = this.handlePetsallowedSelection.bind(this);
        this.handleAddToCart = this.handleAddToCart.bind(this);
        this.handleShowRoom = this.handleShowRoom.bind(this);
        this.handleBackToSearch = this.handleBackToSearch.bind(this);
        this.handleUpdateCart = this.handleUpdateCart.bind(this);
        this.handleShowCart = this.handleShowCart.bind(this);
    }

    handleRoomsSelection(rooms){
        this.setState({rooms: rooms}, ()=>{this.props.onSearchResult(this.state)});
    }

    handlePersonsSelection(persons){
        this.setState({persons: persons}, ()=>{this.props.onSearchResult(this.state);this.searchData()});
    }

    handleReasonSelection(reason){
        this.setState({reason: reason}, ()=>{this.props.onSearchResult(this.state)});
    }

    handleBreakfastSelection(val){
        this.setState({breakfast: val ? true : false}, ()=>{this.props.onSearchResult(this.state)});
    }

    handleDoublebedSelection(val){
        this.setState({doublebed: val ? true : false}, ()=>{this.props.onSearchResult(this.state)});
    }

    handleKitchenSelection(val){
        this.setState({kitchen: val ? true : false}, ()=>{this.props.onSearchResult(this.state)});
    }

    handlePlaceforkidsSelection(val){
        this.setState({placeforkids: val ? true : false}, ()=>{this.props.onSearchResult(this.state)});
    }

    handlePetsallowedSelection(val){
        this.setState({petsallowed: val ? true : false}, ()=>{this.props.onSearchResult(this.state)});
    }

    handleCodeUpdate(event){
        this.setState({code: event.target.value}, ()=>{this.props.onSearchResult(this.state)});
    }

    handleIntervalselection(interval){
        this.setState({dateInterval: interval}, ()=>{this.props.onSearchResult(this.state)});
    }

    handleAddToCart(cartItem){
        this.props.onAddToCart(cartItem);
    }

    handleShowRoom(item){
        this.setState({show: item});
        this.props.onShowRoom(true);
    }

    handleBackToSearch(){
        this.setState({show: null});
        this.props.onShowRoom(false);
    }

    handleUpdateCart(cart){
        this.props.onUpdateCart(cart);
    }

    handleShowCart(){
		this.props.onShowCart();
	}

    searchData(){
        if(this.state.dateInterval !== ''){
            this.setState({isSearching:true});            
            axios.get('./API/get_objects.json')
                .then(response => {
                    setTimeout(()=>{ //loading simulation
                        this.setState({
                            isSearching:false,
                            foundObjects:response.data,
                            searchStarted : true                               
                        });
                        if(this.props.onSearchResult !== undefined && this.props.onSearchResult !== ''){
                            this.props.onSearchResult(this.state);
                        }
                    }, 1000);
                })
                .catch(error => {
                    console.log(error);
                })           
        }else{
            alert('Please select check in dates.');
        }        
    }

    componentDidMount(){
        if(this.state.searchStarted){
            this.searchData()
        }
    }

    render() { 

        if(this.state.show !== null){
            return(
                <div id="room">

                    <Navigation cartItems={this.props.cart} 
                                navlogo={true} 
                                onUpdateCart={this.handleUpdateCart}
                                onShowCart={this.handleShowCart}
                    />

                    <ShowRoom room={this.state.show} 
                              onBackToSearch={this.handleBackToSearch}
                              promocode={this.state.code}
                              numPersons={this.state.persons}
                              searchReason = {this.state.reason}
                              dateInterval={this.state.dateInterval}
                    />
                </div>
            )
        }else{
            return(
                <div id="finder">
                    <MediaQuery query="(min-width: 600px)">
                        <div className="vb-left-col">
                            <div className="vb-leftcontent-1 height570px">
                                <div className="vb-logo">
                                    <a href="./" title="">
                                    { this.state.searchStarted ? <img className="logo-small" src="./images/logo_intourist.png" alt="" /> : <img src="./images/logo_intourist.png" alt="" /> }                                
                                    </a>
                                </div>
        
                                { !this.state.searchStarted ? <h2>Reservation</h2> : ''}
                                <div className="vb-checkin-box">
                                    <label>Check in</label>
                                    <Calendar value={this.state.dateInterval} onSelect={this.handleIntervalselection} numberOfCalendars={2}/>
                                </div>
                                
        
                                <div className="vb-rooms-code">
                                    <div className="vb-rooms-box">
                                        <label>Rooms</label>
                                        <Dropdown
                                                value={this.state.rooms}
                                                options={roomsOptions}
                                                placeholder='All rooms'
                                                onChange={this.handleRoomsSelection}
                                                className='vb-select-rooms'
                                                name="rooms"
                                        />
                                    </div>
                                    <div className="vb-code-box">
                                        <label>Code</label>
                                        <div className="vb-code">
                                            <input type="text" value={this.state.code} onChange={this.handleCodeUpdate} placeholder="enter code"/>
                                        </div>
                                    </div>
                                </div>
                                <button className="vb-search-button" onClick={this.searchData}>
                                    <span>Search</span>
                                    <i></i>
                                </button>
        
                                <Filter 
                                    visible={this.state.searchStarted}
                                    onSelectPersons={this.handlePersonsSelection} 
                                    onSelectReason={this.handleReasonSelection} 
                                    onCheckBreakfast={this.handleBreakfastSelection}
                                    onCheckDoublebed={this.handleDoublebedSelection}
                                    onCheckKitchen={this.handleKitchenSelection}
                                    onCheckPlaceforkids={this.handlePlaceforkidsSelection}
                                    onCheckPetsallowed={this.handlePetsallowedSelection}
                                    selectedPersons={this.state.persons}
                                    selectedReason={this.state.reason}
                                    breakfast={this.state.breakfast}
                                    doublebed={this.state.doublebed}
                                    kitchen={this.state.kitchen}
                                    placeforkids={this.state.placeforkids}
                                    petsallowed={this.state.petsallowed}
                                />
        
                                <Promo visible={!this.state.searchStarted}/>                        
        
                            </div>
        
                            <Callback visible={!this.state.searchStarted}/>
                        
                        </div>
        
                        <div className="vb-right-col">
        
                            <Navigation cartItems={this.props.cart} 
                                        onUpdateCart={this.handleUpdateCart}
                                        onShowCart={this.handleShowCart}
                            />
        
                            <HomeBanner visible={!this.state.isSearching && !this.state.searchStarted}/>
        
                            <SearchResult 
                                visible={this.state.isSearching || this.state.searchStarted}
                                isSearching = {this.state.isSearching}
                                foundObjects = {this.state.foundObjects}
                                searchReason = {this.state.reason}
                                numPersons = {this.state.persons}
                                breakfast = {this.state.breakfast}
                                doublebed = {this.state.doublebed}
                                kitchen={this.state.kitchen}
                                placeforkids={this.state.placeforkids}
                                petsallowed={this.state.petsallowed}
                                promocode={this.state.code}
                                dateInterval={this.state.dateInterval}
                                onAddToCart={this.handleAddToCart}
                                onShowRoom={this.handleShowRoom}
                                onShowCart={this.handleShowCart} 
                            />
        
                        </div>
                    </MediaQuery>
                    <MediaQuery query="(max-width: 599px)">

                        <MobileHome 
                            visible={!this.state.isSearching && !this.state.searchStarted}
                            dateInterval={this.state.dateInterval}
                            onDateSelect={this.handleIntervalselection}
                            onRoomsChange={this.handleRoomsSelection}
                            onCodeChange={this.handleCodeUpdate}
                            onSearchData={this.searchData}
                            roomsNumber={this.state.rooms}
                            code={this.state.code}
                        /> 

                        <MobileFilter 
                            visible={this.state.isSearching || this.state.searchStarted}
                            dateInterval={this.state.dateInterval}
                            onDateSelect={this.handleIntervalselection}
                            onRoomsChange={this.handleRoomsSelection}
                            onCodeChange={this.handleCodeUpdate}
                            onSearchData={this.searchData}
                            roomsNumber={this.state.rooms}
                            roomsOptions={roomsOptions}
                            code={this.state.code}
                            onSelectPersons={this.handlePersonsSelection} 
                            onSelectReason={this.handleReasonSelection} 
                            onCheckBreakfast={this.handleBreakfastSelection}
                            onCheckDoublebed={this.handleDoublebedSelection}
                            onCheckKitchen={this.handleKitchenSelection}
                            onCheckPlaceforkids={this.handlePlaceforkidsSelection}
                            onCheckPetsallowed={this.handlePetsallowedSelection}
                            selectedPersons={this.state.persons}
                            selectedReason={this.state.reason}
                            breakfast={this.state.breakfast}
                            doublebed={this.state.doublebed}
                            kitchen={this.state.kitchen}
                            placeforkids={this.state.placeforkids}
                            petsallowed={this.state.petsallowed}
                        />

                        <SearchResult 
                                visible={this.state.isSearching || this.state.searchStarted}
                                isSearching = {this.state.isSearching}
                                isMobile = {true}
                                foundObjects = {this.state.foundObjects}
                                searchReason = {this.state.reason}
                                numPersons = {this.state.persons}
                                breakfast = {this.state.breakfast}
                                doublebed = {this.state.doublebed}
                                kitchen={this.state.kitchen}
                                placeforkids={this.state.placeforkids}
                                petsallowed={this.state.petsallowed}
                                promocode={this.state.code}
                                dateInterval={this.state.dateInterval}
                                onAddToCart={this.handleAddToCart}
                                onShowRoom={this.handleShowRoom}
                                onShowCart={this.handleShowCart}                                 
                        />

                    </MediaQuery>
                    
                </div>
                
            )
        }        
    }

}

export default Finder;